<template>
  <div class="iconInput"> 
    <Dropdown :popper-class="popperClass" >
      <button class="iconSelector">
        <i class="iconfont2" :class="value" />
      </button>
      <template #popper>
         <icon-picker @input="iconChanged" :series="series" :iconsSet="iconsSet"/>
      </template>
    </Dropdown>
  </div>
</template>
<style>
.iconInput {
  display: inline-block;
  text-align: center;
}
.iconSelector {
  width:75px;
  border: 1px solid #c5c5c5;
  border-radius: 0px;
  background-color: white;
  color: #000;
}
.iconSelector:hover {
  background-color: #F5F7FA;
}
</style>
<script>
import IconPicker from './IconPicker.vue';
import { Dropdown } from 'floating-vue';
import { hideAllPoppers } from 'floating-vue'
import 'floating-vue/dist/style.css'

export default {
  name: "IconInput",
  components: {
    IconPicker,
    Dropdown
  },
  props: ['value', 'popperClass', 'series', 'iconsSet'],
  methods: {
    iconChanged(value) {
      this.$emit('input', value);
      hideAllPoppers();
    }
  }
};
</script>
